import { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, MessageCircle, Printer, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "../../lib/api";
import { formatARS } from "../../lib/site";

const waPhone = (p) => {
  const d = String(p || "").replace(/\D/g, "").replace(/^0/, "");
  return d ? (d.startsWith("54") ? d : `54${d}`) : "";
};

export const waText = (j) => `Hola ${j.client}, te paso el presupuesto ${j.code} de Santiagueño: ${j.origin} → ${j.destination}, ${j.date}${j.return_date ? ` al ${j.return_date}` : ""}. Precio ${formatARS(j.price)} + impuestos.${j.accept_token ? ` Podés verlo y aceptarlo acá: ${window.location.origin}/presupuesto/${j.accept_token}` : ""}`;

export const QuoteActions = ({ j, onDone }) => {
  const [email, setEmail] = useState(j.client_email || "");
  const [busy, setBusy] = useState(false);
  const send = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.post(`/fleet/jobs/${j.id}/send`, { email }); toast.success(`Presupuesto enviado a ${email}`); onDone(); } catch (err) { toast.error(apiError(err)); } finally { setBusy(false); }
  };
  const phone = waPhone(j.client_phone);
  const btn = "inline-flex h-9 items-center gap-1.5 rounded-full px-4 text-xs font-bold";
  return (
    <div className="flex flex-wrap items-center gap-2">
      <Link to={`/admin/presupuesto/${j.id}`} data-testid={`job-print-${j.code}`} className={`${btn} bg-[var(--paper)] text-[var(--ink)]`}><Printer className="h-4 w-4" /> Ver e imprimir</Link>
      <form onSubmit={send} className="flex flex-wrap items-center gap-2">
        <input data-testid={`job-email-${j.code}`} type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email del cliente" className="h-9 w-56 rounded-lg border border-black/10 px-2" />
        <button disabled={busy} data-testid={`job-send-${j.code}`} className={`${btn} bg-[var(--forest)] text-white`}>{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Mail className="h-4 w-4" />} Enviar por email</button>
      </form>
      {phone && <a href={`https://wa.me/${phone}?text=${encodeURIComponent(waText(j))}`} target="_blank" rel="noopener noreferrer" data-testid={`job-wa-${j.code}`} className={`${btn} bg-[#25D366] text-[var(--ink)]`}><MessageCircle className="h-4 w-4" /> WhatsApp</a>}
      {j.sent_at && <span data-testid={`job-sent-${j.code}`} className="text-xs text-[var(--muted-ink)]">Enviado {new Date(j.sent_at).toLocaleString("es-AR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" })} a {j.client_email}</span>}
    </div>
  );
};
